import { createRoute } from '@tanstack/react-router';
import { Route as parent } from './site.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: 'redirects' }).lazy(() =>
  import('./site-redirects.lazy.tsx').then((module) => module.Route),
);
